// Decimal filter

import func from '@/shared/services/functions'

export default (value, number) => {
  if (func.isEmpty(value)) return ''
  if (value.toFixed) return value.toFixed(number || 2).replace(/\B(?=(?=\d*\.)(\d{3})+(?!\d))/g, ',')
  return NaN
}
